import { render } from "./AppFrameDesc.vue?vue&type=template&id=b5621096"
import script from "./AppFrameDesc.vue?vue&type=script&lang=js"
export * from "./AppFrameDesc.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__